import React from 'react';
import { DIGIT_BALL_KEYS, DIGIT_HEADERS } from './DigitDifferenceMatrix';

const MetricCell = ({ metric, id, checks = false }) => (
  <td data-testid={id}>
    <div className="font-semibold text-gray-900" data-testid={`${id}-percentage`}>{metric?.pct == null ? '—' : `${metric.pct.toFixed(2)}%`}</div>
    <div className="digit-repeat-count text-gray-500" data-testid={`${id}-counts`}>
      <span>{metric?.hits ?? 0}</span><span> / </span><span>{metric?.opportunities ?? 0}</span>
      <span className="block">{checks ? 'checks' : 'pairs'}</span>
    </div>
  </td>
);

const RepeatRow = ({ row, id }) => (
  <tr data-testid={`${id}-row`}>
    <th scope="row" data-testid={`${id}-digit`}>{row.digit == null ? 'All digits' : row.digit}</th>
    <MetricCell metric={row.overall} id={`${id}-overall`} />
    {DIGIT_BALL_KEYS.map(key => <MetricCell key={key} metric={row.balls[key]} id={`${id}-${key}`} />)}
    <MetricCell metric={row.grand_total} id={`${id}-grand-total`} checks />
  </tr>
);

export const DigitRepeatMatrix = ({ group, title }) => (
  <section className="space-y-3 border-t border-gray-200 pt-6" data-testid={`digit-repeat-${group.source}-section`}>
    <div className="flex flex-wrap items-center justify-between gap-2">
      <h2 className="text-base font-bold text-gray-900" data-testid={`digit-repeat-${group.source}-heading`}>{title}</h2>
      <span className="text-xs text-gray-500" data-testid={`digit-repeat-${group.source}-pairs`}>{group.valid_pairs.toLocaleString()} valid draw pairs</span>
    </div>
    <table className="digit-summary-matrix digit-repeat-matrix" data-testid={`digit-repeat-${group.source}-table`}>
      <thead><tr>{DIGIT_HEADERS.map((name, i) => <th key={name} scope="col" data-testid={`digit-repeat-${group.source}-heading-${i}`}>
        {name}{i === 1 && <small className="block font-normal">Any ball</small>}{i === 7 && <small className="block font-normal">Five positions</small>}
      </th>)}</tr></thead>
      <tbody>{group.rows.map(row => <RepeatRow key={row.digit} row={row} id={`digit-repeat-${group.source}-${row.digit}`} />)}</tbody>
      <tfoot><RepeatRow row={group.summary} id={`digit-repeat-${group.source}-all`} /></tfoot>
    </table>
  </section>
);
